import { render, staticRenderFns } from "./DataSetFileMetadataForm.vue?vue&type=template&id=5c900efe&scoped=true"
import script from "./DataSetFileMetadataForm.vue?vue&type=script&lang=js"
export * from "./DataSetFileMetadataForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c900efe",
  null
  
)

export default component.exports